import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useEffect } from 'react';
import { CurrencyInput } from '../../utils/CurrencyInput';
import { IconX } from '@tabler/icons-react';

export default function TambahPengeluaran({
  loadingSubmit,
  isOpenTambahPengeluaran,
  handleSubmitPengeluaran,
  handleEditPengeluaran,
  isEdit,
  formData,
  nominal,
  setNominal,
  handleOnChange,
  closeModalTambahPengeluaran,
}) {
  useEffect(() => {
    if (!isOpenTambahPengeluaran && !isEdit) {
      setNominal(0);
    }
  }, [isOpenTambahPengeluaran, isEdit, setNominal]);

  return (
    <Transition appear show={isOpenTambahPengeluaran} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={loadingSubmit ? () => {} : closeModalTambahPengeluaran}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-slate-900/60 dark:bg-slate-950/80 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-lg transform overflow-hidden rounded-2xl bg-white dark:bg-slate-900 p-6 text-left align-middle shadow-2xl transition-all border border-slate-200 dark:border-slate-800">
                {/* Header */}
                <div className="flex items-start justify-between pb-3.5 mb-4 border-b border-slate-100 dark:border-slate-800">
                  <div>
                    <Dialog.Title
                      as="h3"
                      className="text-xl font-bold text-slate-800 dark:text-slate-100"
                    >
                      {isEdit ? 'Edit Pengeluaran' : 'Masukkan Pengeluaran'}
                    </Dialog.Title>
                    <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">
                      {isEdit
                        ? 'Perbarui data transaksi pengeluaran.'
                        : 'Isi data transaksi pengeluaran.'}
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={closeModalTambahPengeluaran}
                    disabled={loadingSubmit}
                    className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors p-1 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 disabled:opacity-40"
                  >
                    <IconX size={20} />
                  </button>
                </div>

                {/* Form Fields */}
                <form
                  onSubmit={isEdit ? handleEditPengeluaran : handleSubmitPengeluaran}
                >
                  <div className="space-y-4">
                    {/* Nominal */}
                    <div>
                      <label
                        htmlFor="nominal"
                        className="block text-sm font-semibold text-slate-800 dark:text-slate-200 mb-1.5"
                      >
                        Nominal
                      </label>
                      <CurrencyInput
                        id="nominal"
                        name="nominal"
                        value={nominal}
                        autoComplete="off"
                        onChange={(value) => setNominal(value)}
                        className="w-full px-3.5 py-2.5 rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 text-sm focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 outline-none transition-all placeholder:text-slate-400"
                        placeholder="Rp 0"
                      />
                      <p className="text-xs text-slate-400 dark:text-slate-500 mt-1">
                        Otomatis berformat mata uang.
                      </p>
                    </div>

                    {/* Tipe */}
                    <div>
                      <label
                        htmlFor="tipe"
                        className="block text-sm font-semibold text-slate-800 dark:text-slate-200 mb-1.5"
                      >
                        Tipe
                      </label>
                      <select
                        id="tipe"
                        name="tipe"
                        value={formData?.tipe || ''}
                        onChange={handleOnChange}
                        className="w-full px-3.5 py-2.5 rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 text-sm focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 outline-none transition-all cursor-pointer"
                        required
                      >
                        <option value="">Pilih Tipe Transaksi</option>
                        <option value="pemasukan">Pemasukan</option>
                        <option value="tambah-kas">Tambah KAS</option>
                        <option value="tarik-kas">Tarik KAS</option>
                        <option value="m-banking">M-Banking</option>
                        <option value="digitalpay-transfer">DigitalPay Transfer</option>
                        <option value="digitalpay-qris">DigitalPay QRIS</option>
                        <option value="digitalpay-edc-debit-kredit">DigitalPay EDC/DEBIT/KREDIT</option>
                        <option value="gaji-karyawan">Gaji Karyawan</option>
                        <option value="indihome">Indihome</option>
                        <option value="asuransi">Asuransi</option>
                        <option value="listrik">Listrik</option>
                        <option value="bensin">Bensin</option>
                        <option value="parkir">Parkir</option>
                        <option value="makan">Makan</option>
                        <option value="donasi-santunan">Donasi dan Santunan</option>
                        <option value="pengeluaran-lainnya">Pengeluaran Lainnya</option>
                      </select>
                    </div>

                    {/* Keterangan */}
                    <div>
                      <label
                        htmlFor="message"
                        className="block text-sm font-semibold text-slate-800 dark:text-slate-200 mb-1.5"
                      >
                        Keterangan
                      </label>
                      <textarea
                        id="message"
                        rows={3}
                        name="keterangan"
                        value={formData?.keterangan || ''}
                        onChange={handleOnChange}
                        className="w-full px-3.5 py-2.5 rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 text-sm focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 outline-none transition-all placeholder:text-slate-400 resize-y"
                        placeholder="Keterangan transaksi pengeluaran..."
                      />
                    </div>
                  </div>

                  {/* Actions */}
                  <div className="flex items-center justify-end gap-2.5 pt-4 mt-5 border-t border-slate-100 dark:border-slate-800">
                    <button
                      type="button"
                      onClick={closeModalTambahPengeluaran}
                      disabled={loadingSubmit}
                      className="px-4 py-2 text-sm font-semibold text-slate-700 dark:text-slate-300 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 rounded-lg transition-colors disabled:opacity-50"
                    >
                      Batal
                    </button>
                    <button
                      type="submit"
                      disabled={loadingSubmit}
                      className="px-5 py-2 text-sm font-semibold text-white bg-amber-500 hover:bg-amber-600 active:bg-amber-700 rounded-lg shadow-sm hover:shadow transition-all disabled:opacity-50 flex items-center gap-1.5"
                    >
                      {loadingSubmit ? (
                        <>
                          <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
                          <span>Memproses...</span>
                        </>
                      ) : (
                        <span>{isEdit ? 'Update' : 'Simpan'}</span>
                      )}
                    </button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
